import {
  StudentActivityInfo,
  StudentActivityTableInfo,
} from "@/models/activity.model";
import moment from "moment";

function toDomain(
  activities: StudentActivityInfo[]
): StudentActivityTableInfo[] {
  return activities?.map((activity) => {
    return {
      activityId: activity?.activityId,
      title: activity?.title,
      info: formatInfo(activity),
      status: formatStatus(activity),
    };
  });
}

function toDomainActivity(activities: any): any {
  return {
    ...activities,
    status: formatStatus(activities),
  };
}

function formatInfo(activity: any) {
  const info = {
    FEEDBACK: () =>
      `<h6>Nota</h6> <p class="bg-h-primary-100 py-1 px-2 rounded-md font-bold">${activity.score} / ${activity.scoreRange}<p>`,
    OVERDUE: () => moment(activity?.finalDate).locale("pt-br").format("LLL"),
    ASSIGNED: () => "",
  };

  const formatter = info[activity?.status!];
  return typeof formatter === "function" ? formatter() : info.OVERDUE();
}

function formatStatus(activity: any) {
  const status = {
    FEEDBACK: () => ({
      class: `bg-h-success-50 text-h-success-500 p-2 rounded-md`,
      icon: `bi-check-circle-fill`,
      text: `Corrigido`,
      tooltip: `O professor enviou a sua nota final que poderá conter também um feedback.`,
      value:"FEEDBACK"
    }),
    OVERDUE: () => ({
      class: `bg-h-warning-50 text-h-warning-500 p-2 rounded-md`,
      icon: `io-time-sharp`,
      text: `Não Enviado`,
      tooltip: `A atividade experiou o prazo de entrega e não poderá ser editada ou enviada.`,
      value:"OVERDUE",
    }),
    ASSIGNED: () => ({
      class: `bg-h-primary-50 text-h-primary-500 p-2 rounded-md`,
      icon: `io-time-sharp`,
      text: `Em Andamento`,
      tooltip: `A atividade foi iniciada e poderá ser editada antes de expirar o prazo final.`,
      value:"ASSIGNED",
    }),
    NOT_STARTED: () => ({
      class: `bg-h-warning-50 text-h-warning-800 p-2 rounded-md`,
      icon: `ri-error-warning-line`,
      text: `Não iniciada`,
      tooltip: `A atividade foi atribuída, mas ainda não foi iniciada.`,
      value:"NOT_STARTED",
    }),
  };

  const formatter = status[activity.status];
  return typeof formatter === "function" ? formatter() : status.NOT_STARTED();
}
export { toDomain, toDomainActivity };
